export function formatCPF(cpf: String = ""): String {
  let value = cpf;
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d)(\d{2})$/, '$1-$2');
  value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');
  return value;
}
